import { create } from 'zustand';

type ConversationStatus = 'idle' | 'loading' | 'completed';

interface ConversationStatusState {
  conversationStatus: ConversationStatus;
  setConversationStatus: (status: ConversationStatus) => void;
  resetConversationStatus: () => void;
}

export const useConversationStatusStore = create<ConversationStatusState>(
  (set) => ({
    conversationStatus: 'idle',

    setConversationStatus: (status: ConversationStatus) =>
      set({ conversationStatus: status }),

    resetConversationStatus: () => set({ conversationStatus: 'idle' }),
  }),
);
